import { useServicesContext } from "@modules/core/services/services.context"
import { useSuspenseQuery } from "@tanstack/react-query"

export const useProgramSasRequestTotal = (programId: string, startDate?: Date) => {
  const { programSasApi } = useServicesContext()
  const { data, isLoading, refetch } = useSuspenseQuery({
    queryKey: ["programSasRequestTotal", programId, startDate],
    queryFn: async () => {
      return await programSasApi.getProgramSasTotalPendingSubscriptions(programId, startDate)
    },
  })

  return {
    data,
    refetch,
    isLoading,
  }
}
